const pages = [
    {
        //结果页面
        path:'common/result',
        name:'common.result',
        component:()=>import('../../views/common/result')
    }
];

export default pages;